import { useMutation } from '@tanstack/react-query';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GENERATE_MODULE } from '../mutations/generateModule';
import { GenerateModuleInput, GenerateModuleOutput } from '../gql/graphql';

export const useGenerateModule = () => {
  return useMutation<GenerateModuleOutput, Error, GenerateModuleInput>({
    mutationFn: async (input) => {
      const data = await graphqlFetch<
        { generateSections: GenerateModuleOutput },
        { input: GenerateModuleInput }
      >(GENERATE_MODULE, { input });
      return data.generateSections;
    },
  });
};
